import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Configurations } from '../../../Utils/Configurations';
import '../Reports.scss';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import { RelatorioNominal } from 'ebs-orders-reports-react-lib';

class Nominal extends Component {
    constructor(props) {
        super(props);

        this.handleOrg = this.handleOrg.bind(this);
        this.handlePeriodo = this.handlePeriodo.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.getRelatorioMensal = this.getRelatorioMensal.bind(this);

        this.state = {
            dataSelecionada: new Date(),

            isLoadingDadosParaGraficos: true,

            hasError: false,
            errorMessage: '',
            exibeAlertaSemDados: false,

            dadosParaGraficos: []
        }

        this.Configurations = new Configurations();
    }

    getRelatorioMensal() {
        const { dataSelecionada, orgSelecionada } = this.state;
        this.setState({ isLoadingDadosParaGraficos: true })
        axios.get(this.Configurations.apiBasePath + "/relatorio/assinaturas/membros/mensal?dtReferencia=" + (moment(dataSelecionada).format('YYYY-MM-DD')) + "&organizacao=" + (orgSelecionada)).then(response => {
            if (response.data.semDados) {
                this.setState({ exibeAlertaSemDados: true })

            } else {
                this.setState({
                    dadosParaGraficos: response.data,
                    exibeAlertaSemDados: false
                })
            }
        }).catch(this.handleError).finally(() => {
            this.setState({
                isLoadingDadosParaGraficos: false,
            })
        });
    }

    handleError(err) { this.setState({ hasError: true, errorMessage: err.message }) }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    handleOrg(eValue) {
        this.setState({ orgSelecionada: eValue, flagBusca: true }, () => {
            if (this.state.orgSelecionada.split("@").length > 4) {
                this.getRelatorioMensal();
            } else {
                this.setState({ exibeAlertaSemDados: true })
            }
        });
    }

    handlePeriodo(eValue) {
        this.setState({ dataSelecionada: eValue }, () => {
            if (this.state.orgSelecionada.split("@").length > 4) {
                this.getRelatorioMensal();
            } else {
                this.setState({ exibeAlertaSemDados: true })
            }
        });
    }

    render() {
        const {
            orgSelecionada, flagBusca, dataSelecionada,
            dadosParaGraficos, isLoadingDadosParaGraficos,
            hasError, errorMessage, exibeAlertaSemDados
        } = this.state;
        return (
            <React.Fragment>
                <RelatorioNominal
                    handleOrg={this.handleOrg}
                    orgSelecionada={orgSelecionada}
                    handlePeriodo={this.handlePeriodo}
                    dataSelecionada={dataSelecionada}
                    dadosParaGraficos={dadosParaGraficos}
                    isLoadingDadosParaGraficos={isLoadingDadosParaGraficos}
                    apiBasePath={this.Configurations.apiBasePath}
                    tokenKey={this.Configurations.tokenKey}
                    flagBusca={flagBusca}
                    exibeAlertaSemDados={exibeAlertaSemDados}
                    fukyo={true}
                    nivelBusca={4}
                />
                <ErrorModal isOpen={hasError} message={errorMessage} closeErrorModal={this.closeErrorModal} />
            </React.Fragment>
        )
    }
}

export default Nominal;